<script>
  export let bubbleData;
</script>

<div style="text-align:right">
  <div class="chatwith-bubble-user">
    {bubbleData.type === 'file' ? bubbleData.name : bubbleData.val}
  </div>
</div>
